import { useUpdateIndustryMutation } from "@/pages/Private/redux/industry/industry.api";

import { Industry, IndustrySchema } from "../../industry/schema/industry";
import EditModeIndustryItem from "./EditModeIndustryItem";
import ViewModeIndustryItem from "./ViewModeIndustryItem";

interface EditableIndustryItemProps {
	data: Industry;
	isEditing: boolean;
	isEditingInProcess: boolean;
	setEditing: (value: number) => void;
	setDeletingIndustry: (value: Industry | null) => void;
}

export default function EditableIndustryItem({
	data,
	isEditing,
	setEditing,
	setDeletingIndustry,
	isEditingInProcess,
}: EditableIndustryItemProps) {
	const [updateIndustry, { isLoading }] = useUpdateIndustryMutation();

	const handleUpdateIndustry = async (values: Industry) => {
		try {
			await updateIndustry(values);
		} catch (error) {
			console.error(error);
		}
	};

	return isEditing ? (
		<EditModeIndustryItem
			data={data}
			isLoading={isLoading}
			setEditing={setEditing}
			validationSchema={IndustrySchema}
			onSubmit={handleUpdateIndustry}
		/>
	) : (
		<ViewModeIndustryItem
			data={data}
			isEditingInProcess={isEditingInProcess}
			isLoading={false}
			setDeletingIndustry={setDeletingIndustry}
			setIsEditing={setEditing}
		/>
	);
}
